export default __webpack_public_path__ + "b7c1464dd02fdcfd323588c65e417322.svg";